<template>
  <Layout>
    <GoBack class="mb-5" text="shottracker news" link="VideosPage" />
    <Title class="my-4" text="Edit Video" />
    <LoadingSpinner v-if="loading.display" :message="loading.message" />
    <UploadVideo v-else :form="videoData" @handleSubmit="handleSubmit" />
  </Layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoadingSpinner from "../../LoadingSpinner.vue";
import Layout from "../../Layout.vue";
import UploadVideo from "./VideoForm.vue";
import GoBack from "../../GoBack.vue";
import initData from "../../../mixins/initData";
import Title from "../Title.vue";

export default {
  name: "EditVideo",
  mixins: [initData],

  components: {
    Layout,
    UploadVideo,
    GoBack,
    LoadingSpinner,
    Title,
  },

  data() {
    return {
      loading: {
        display: false,
        message: "",
      },
      videoData: {},
    };
  },

  computed: {
    ...mapGetters(["directory", "videosID"]),

    noVideos() {
      return this.directory.videos.length === 0;
    },
  },

  methods: {
    ...mapActions(["updateVideoInS3"]),

    getVideo(identifier) {
      return this.directory.videos.find((video) => video.id === identifier);
    },

    setLoadingMessage(message) {
      this.loading.message = message;
      this.loading.display = true;
    },

    async handleSubmit() {
      const updatedIndex = this.videoData;
      const key = this.videosID.directoryKey;

      this.setLoadingMessage("Updating video");
      const data = { updatedIndex, key };
      await this.updateVideoInS3(data);
      this.loading.display = false;

      this.$router.push({
        name: "VideosPage",
      });
    },
  },

  async created() {
    const identifier = this.$route.params.id;

    if (this.noVideos) {
      this.setLoadingMessage("Loading video");
      await this.initData(this.videosID);
      this.loading.display = false;
    }

    this.setLoadingMessage("Loading video");
    this.videoData = await this.getVideo(identifier);
    this.loading.display = false;
  },
};
</script>
